export default "__VITE_ASSET__vA1UlF3u__"